export default "__VITE_ASSET__BKD6tqMX__"